export const partnerssvg = [
  'aj',
  'bluelightcard',
  'honestjohn',
  'parkers',
  'motors',
  'selectcar',
  'regit',
  'rac',
  'heycar',
  'newcarcontract',
  'varissa',
  'confused',
  'gapless',
  'cartaxcheck',
  'vehiclesmart',
  'carveto',
  'totalcarcheck',
  'carguide',
  'checkmot',
  'motorly',
  'motoreasy',
  'flowcar',
  'mycarcheck',
  'intelligentcar',
  'autocar',
  'carmoney',
  'ukcardiscount',
  'ukcarline',
  'whatcar',
  'yesauto',
  'moneysupermarket',
  'gocompare',
  'autofunder',
  'moneyshake',
  'leasingoptions',
  'theautoexperts',
  'carleasespecialoffers',
  'centralvehicle',
  'carparison',
  'cars2buy',
  'exchangeandmart',
  'firstvehicle',
  'leasingcom',
  'thecarexpert',
  'justpark',
  'autoexpress',
  'carbuyer',
  'carthrottle',
  'buyacar',
  'drivingelectric',
  'evo',
  'stablevehicle',
  'motiv',
  'theaa',
  'theaalease',
  'loveelectric',
  'octopusev',
  'rapidcarcheck',
  'zuto',
  'joemedia',
  'carplus',
  'clearscore',
  'fullcarchecks',
  'gumtree',
  'caranalytics',
  'brumble',
  'compareni',
] as const;

export const partnerspng = [
  'autovillage',
  'cardatachecks',
  'cardealermag',
  'carsitenetwork',
  'caura',
  'checkcardetails',
  'desperateseller',
  'drover',
  'kidstart',
  'leaseloco',
  'lovemoney',
  'mustard',
  'onlinecars',
  'petrolprices',
  'pitstop',
  'quidco',
  'quotezone',
  'topcashback',
  'usedcarguy',
  'vehiclecontracts',
  'carloansuk',
  'carvaluationuk',
] as const;

export type AffiliateType = typeof partnerssvg[number] | typeof partnerspng[number];

export const isPartnerSvg = (partner: AffiliateType) => partnerssvg.includes(partner as typeof partnerssvg[number]);
export const isPartnerPng = (partner: AffiliateType) => partnerspng.includes(partner as typeof partnerspng[number]);
